/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exporting_Results_WaitInputs */

const en_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporting results... please wait...`)
};

const fr_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation des résultats... veuillez patienter...`)
};

const de_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergebnisse werden exportiert... Bitte warten...`)
};

const it_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione dei risultati... attendere prego...`)
};

const ru_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт результатов... пожалуйста, подождите...`)
};

const es_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando resultados... por favor espere...`)
};

const zh_cn2_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结果正在导出……请稍候……`)
};

const ja_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結果をエクスポートしています...お待ちください...`)
};

const hi_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`परिणाम निर्यात किए जा रहे हैं... कृपया प्रतीक्षा करें...`)
};

const pt_pt2_exporting_results_wait = /** @type {(inputs: Exporting_Results_WaitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportando resultados... aguarde...`)
};

/**
* | output |
* | --- |
* | "Exporting results... please wait..." |
*
* @param {Exporting_Results_WaitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const exporting_results_wait = /** @type {((inputs?: Exporting_Results_WaitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exporting_Results_WaitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_exporting_results_wait(inputs)
	if (locale === "de") return de_exporting_results_wait(inputs)
	if (locale === "it") return it_exporting_results_wait(inputs)
	if (locale === "ru") return ru_exporting_results_wait(inputs)
	if (locale === "es") return es_exporting_results_wait(inputs)
	if (locale === "zh-CN") return zh_cn2_exporting_results_wait(inputs)
	if (locale === "ja") return ja_exporting_results_wait(inputs)
	if (locale === "hi") return hi_exporting_results_wait(inputs)
	if (locale === "pt-PT") return pt_pt2_exporting_results_wait(inputs)
	return en_exporting_results_wait(inputs)
});